import { SxProps, Theme } from '@mui/material';
import { SPACING } from '../../styles';

export const unitFilterDisplayStyles: SxProps<Theme> = {
  mb: SPACING.MEDIUM,
};
